import styled from 'styled-components';
import { color, container, fontSize, fontWeight, screen, spacing } from 'theme';

export const StyledWrapper = styled.div`
  padding: ${spacing('xl5')} ${spacing('md')};
  position: relative;
  overflow: hidden;
`;

export const StyledContainer = styled.form`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing('xl')};
  z-index: 1;
  position: relative;
  max-width: 34rem;
  color: ${color('text_white')};
  font-size: ${fontSize('lg')};
  line-height: 1.4;

  .phoneNumber {
    max-width: 20rem;
  }
`;

export const StyledHeader = styled.div`
  text-align: center;
  margin-bottom: ${spacing('lg')};
  margin-left: auto;
  margin-right: auto;
  font-size: ${fontSize('md')};

  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.6;
  }
`;

export const StyledTerms = styled.span`
  font-size: ${fontSize('xs')};
  line-height: 1.333;

  a {
    font-weight: ${fontWeight('black')};
    color: ${color('link_inverse')};

    &:hover,
    &:focus {
      color: ${color('link_inverse_hover')};
    }

    &:active {
      color: ${color('link_inverse_active')};
    }
  }
`;

export const StyledHeroImage = styled.div`
  display: none;
  justify-content: space-between;
  align-items: flex-start;
  position: absolute;
  inset: 0;

  @media (min-width: ${container('lg')}) {
    display: flex;
  }

  .astronaut {
    object-fit: contain;
    margin-top: auto;
    height: 32rem;
    margin-right: -3rem;
    margin-bottom: 2rem;
    transform: translateY(0);
    animation: float 6s ease-in-out infinite;
  }

  .planet {
    object-fit: contain;
    height: 15.625rem;
    transform: translateY(0);
    margin-left: ${spacing('xl')};
    margin-top: ${spacing('xl')};
  }

  @keyframes float {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;
